export default __webpack_public_path__ + "static/media/dice.8adc6687.png";